import { LogoMark } from "@/components/Logo";
import { CONTACT, NAV_LINKS } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#080808]">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 md:py-20">
        {/* Giant wordmark */}
        <div className="mb-16 overflow-hidden">
          <h2 className="font-display text-[18vw] leading-[0.8] font-semibold tracking-tighter text-white/5 select-none">
            SC SECURITY
          </h2>
        </div>

        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="text-white">
                <LogoMark className="h-9 w-9" />
              </span>
              <span className="font-display text-lg font-semibold tracking-tight">
                SC<span className="text-cyanbrand">·</span>Security
              </span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm text-white/45 leading-relaxed">
              A division of {CONTACT.parent}. Partner of Ajax Security Systems.
            </p>
          </div>

          <div>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
              Navigate
            </span>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="font-body text-sm text-white/60 hover:text-cyanbrand transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
              Contact
            </span>
            <ul className="mt-4 space-y-3 font-body text-sm">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="text-white/60 hover:text-cyanbrand transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.phoneHref} className="text-white/60 hover:text-cyanbrand transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="text-white/45 max-w-[220px]">{CONTACT.address}</li>
            </ul>
          </div>

          <div>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
              Coverage
            </span>
            <p className="mt-4 font-body text-sm text-white/60">{CONTACT.serviceArea}</p>
            <p className="mt-3 font-body text-sm text-white/45">{CONTACT.hours}</p>
            <a
              href="#quote"
              data-testid="footer-quote-cta"
              className="mt-6 inline-flex rounded-full bg-cyanbrand px-5 py-2.5 text-sm font-semibold text-black transition-transform duration-200 hover:scale-[1.03]"
            >
              Get a quote
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-wider text-white/30">
            © {new Date().getFullYear()} {CONTACT.brand}. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="/login"
              data-testid="footer-staff-login"
              className="font-mono text-[11px] uppercase tracking-wider text-white/30 transition-colors hover:text-cyanbrand"
            >
              Staff login
            </a>
            <p className="font-mono text-[11px] uppercase tracking-wider text-white/30">
              Domestic &amp; Commercial · UK
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
